export default __webpack_public_path__ + "static/media/remove.798ade72.svg";